<template>
  <sidebar
    :addTitle="$t('CashFlow.Lom.AddNew')"
    :editTitle="$t('CashFlow.Lom.Edit')"
    :isSidebarActive="isSidebarActive"
    :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
    <vs-tabs v-model="selectedTab">
      <vs-tab :label="$t('CashFlow.Lom.Tab1')" icon-pack="feather" icon="icon-settings">
        <div class="p-6">
          <vs-row class="mb-3">
            <vs-col vs-w="12">
              <ValidationProvider :name="$t('CashFlow.Lom.Name')" rules="required" v-slot="{ errors }">
                <validated-input
                  :label="$t('CashFlow.Lom.Name')"
                  v-model="projectLomName"
                ></validated-input>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row class="mb-3">
            <vs-col vs-w="12">
              <ValidationProvider :name="$t('CashFlow.Lom.Version')" rules="required|numeric|between:0,20" v-slot="{ errors }">
                <validated-input
                  :label="$t('CashFlow.Lom.Version')"
                  v-model="projectLomVersion"
                ></validated-input>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row class="mb-3">
            <vs-col vs-w="12">
              <ValidationProvider :name="$t('CashFlow.Lom.Description')" v-slot="{ errors }">
                <validated-input
                  :label="$t('CashFlow.Lom.Description')"
                  v-model="projectLomDescription"
                ></validated-input>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="12">
              <form-label>{{$t('CashFlow.ProjectLom.ProjectSource')}}</form-label>
                <vs-row>
                  <vs-col vs-w="6">
                    <vs-radio v-model="selectedProjectSource" :vs-value="EXTERNAL_PROJECT">{{ $t('CashFlow.ProjectLom.ExternalProjectName') }}</vs-radio>
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-radio v-model="selectedProjectSource" :vs-value="HYPERION_PROJECT">{{ $t('CashFlow.ProjectLom.HyperionEntityName') }}</vs-radio>
                  </vs-col>
                </vs-row>
            </vs-col>
          </vs-row>
          <vs-row v-if="showExternalProject" class="mb-3">
            <vs-col vs-w="12">
              <form-label>{{$t('CashFlow.ProjectLom.ExternalProjectName')}}</form-label>
              <ValidationProvider :name="$t('CashFlow.ProjectLom.ExternalProjectName')" rules="required" v-slot="{ errors }">
                <v-select
                  label="name"
                  :options="projects"
                  v-model="projectLomProjectId"
                  :reduce="projectLom => projectLom.id"
                  class="w-full"
                />
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row v-if="showHyperionProject" class="mb-3">
            <vs-col vs-w="12">
              <form-label>{{$t('CashFlow.ProjectLom.HyperionEntityName')}}</form-label>
              <ValidationProvider :name="$t('CashFlow.ProjectLom.HyperionEntityName')" rules="required" v-slot="{ errors }">
                <v-select
                  label="name"
                  :options="hyperionEntities"
                  v-model="projectLomHyperionEntityId"
                  :reduce="hyperionEntity => hyperionEntity.id"
                  class="w-full"
                />
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="space-between" class="mb-3">
            <vs-col vs-w="5.5">
              <form-label>{{$t('CashFlow.LomType.Name')}}</form-label>
              <ValidationProvider :name="$t('CashFlow.LomType.Name')" rules="required" v-slot="{ errors }">
                <v-select
                  label="name"
                  :options="projectLomTypes"
                  v-model="projectLomType"
                  :reduce="projectLomType => projectLomType.id"
                  class="w-full"
                />
                <validation-message
                  >{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
            <vs-col vs-w="5.5">
              <form-label>{{$t('CashFlow.Currency.Name')}}</form-label>
              <ValidationProvider :name="$t('CashFlow.Currency.Name')" rules="required" v-slot="{ errors }">
                <v-select
                  label="name"
                  :options="projectLomCurrencies"
                  v-model="projectLomCurrency"
                  :reduce="projectLomCurrency => projectLomCurrency.id"
                  class="w-full"
                />
                <validation-message
                  >{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row class="mb-3">
            <vs-col vs-w="12">
              <form-label>{{$t('CashFlow.Lom.Availability')}}</form-label>
              <vs-row>
                <vs-checkbox v-model="projectLomIsPublic">Public</vs-checkbox>
              </vs-row>
            </vs-col>
          </vs-row>
        </div>
        <div class="p-6">
          <vs-row>
            <vs-col vs-w="12">
              <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
              <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>
      <vs-tab :label="$t('CashFlow.Lom.Tab2')" icon-pack="feather" icon="icon-upload">
        <div class="p-6" v-if="projectLomId !== null && projectLomId !== 0">
          <!-- Upload file -->
            <form data-vv-scope="tab2">
              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <ValidationProvider :name="$t('CashFlow.Lom.YearAdjustment')" rules="required" v-slot="{ errors }">
                    <validated-input
                      :label="$t('CashFlow.Lom.YearAdjustment')"
                      v-model="projectLomYearAdjustment"
                    ></validated-input>
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-6">
                <vs-col vs-w="12">
                  <form-label>{{$t('CashFlow.Lom.UploadFile')}}</form-label><br />
                  <input type="file" accept=".xlsx" v-on:change="getFile($event)">
                  <div class="mb-3">
                  </div>  
                  <validation-message v-if="showInvalidFileError">{{ $t('CashFlow.Lom.UploadInvalidFileError') }}</validation-message>
                </vs-col>
              </vs-row>
            </form>
            <div>
              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <vs-button :disabled="!file" class="mr-6" @click="uploadFile">{{ $t('Submit') }}</vs-button>
                  <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
                </vs-col>
              </vs-row>
            </div>
        </div>
        <div v-else>
          {{ $t('CashFlow.Lom.ProjectMustBeCreated') }}
        </div>
      </vs-tab>
    </vs-tabs>
    </ValidationObserver>
  </sidebar>
</template>

<script>
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../shared/components";

import CurrencyEnum from "./../../CurrencyEnum.js";
import LomTypeEnum from "./../../LomTypeEnum.js";
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    Sidebar,
    'v-select': vSelect
  },
  data() {
    return {
      projectLomId: 0,
      projectLomName: "",
      projectLomVersion: 0,
      projectLomDescription: "",
      selectedProjectSource: this.EXTERNAL_PROJECT,
      projectLomProjectId: null,
      projectLomHyperionEntityId: 0,
      projectLomType: null,
      projectLomTypes: [
        { id:LomTypeEnum.LOM, name: this.$t("CashFlow.LomType." + LomTypeEnum.LOM) },
        { id:LomTypeEnum.ELOM, name: this.$t("CashFlow.LomType." + LomTypeEnum.ELOM) },
        { id:LomTypeEnum.Budget, name: this.$t("CashFlow.LomType." + LomTypeEnum.Budget) },
        { id:LomTypeEnum.BuExtensiondget, name: this.$t("CashFlow.LomType." + LomTypeEnum.Extension) },
        { id:LomTypeEnum.EvaluationScenario, name: this.$t("CashFlow.LomType." + LomTypeEnum.EvaluationScenario) },
        { id:LomTypeEnum.FPM, name: this.$t("CashFlow.LomType." + LomTypeEnum.FPM) }
      ],
      projectLomCurrency: null,
      projectLomCurrencies: [
        { id:CurrencyEnum.USD, name: this.$t("CashFlow.Currency." + CurrencyEnum.USD) },
        { id:CurrencyEnum.CAD, name: this.$t("CashFlow.Currency." + CurrencyEnum.CAD) },
        { id:CurrencyEnum.EUR, name: this.$t("CashFlow.Currency." + CurrencyEnum.EUR) },
        { id:CurrencyEnum.MXN, name: this.$t("CashFlow.Currency." + CurrencyEnum.MXN) }
      ],
      projectLomFileContent: "",
      projectLomYearAdjustment: 0,
      projectLomIsPublic: 0,
      file: "",
      showInvalidFileError: 0,
      selectedTab: 0
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    projects() {
      return this.$store.state.cashflow.projects;
    },
    hyperionEntities() {
      return this.$store.state.cashflow.hyperionEntities;
    },
    showExternalProject() {
      return this.selectedProjectSource === this.EXTERNAL_PROJECT;
    },
    showHyperionProject() {
      return this.selectedProjectSource === this.HYPERION_PROJECT;
    }
  },
  created() {
    this.EXTERNAL_PROJECT = 0;
    this.HYPERION_PROJECT = 1;
  },
  methods: {
    getFile(event) {
      if (event.target.files.length > 0) {
        if (event.target.files[0].name !== null && event.target.files[0].name !== "undefined") {
          if (event.target.files[0].name.search(".xlsx") !== -1) {
            this.file = event.target.files[0];
            this.showInvalidFileError = 0;
          }
          else {
            this.showInvalidFileError = 1;
          }
        }
      }
    },
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const {id, name, version, description, projectId, hyperionEntityId, type, currency, fileContent, yearAdjustment, isPublic} = JSON.parse(JSON.stringify(this.data));
      this.projectLomId = id;
      this.projectLomName = name;
      this.projectLomVersion = version;
      this.projectLomDescription = description;
      if (projectId !== null && projectId > 0) {
        this.selectedProjectSource = this.EXTERNAL_PROJECT;
        this.projectLomProjectId = projectId;
        this.projectLomHyperionEntityId = "";
      }
      else {
        this.selectedProjectSource = this.HYPERION_PROJECT;
        this.projectLomProjectId = null;
        this.projectLomHyperionEntityId = hyperionEntityId;
      }
      this.projectLomType = type;
      this.projectLomCurrency = currency;
      this.projectLomFileContent = fileContent;
      this.projectLomYearAdjustment = yearAdjustment;
      this.projectLomIsPublic = isPublic;
      this.file = "";
      this.selectedTab = 0;
      this.showInvalidFileError = 0;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.projectLomId = 0;
      this.projectLomName = "";
      this.projectLomVersion = 0;
      this.projectLomDescription = "";
      this.selectedProjectSource = this.EXTERNAL_PROJECT;
      this.projectLomProjectId = null;
      this.projectLomHyperionEntityId = "";
      this.projectLomType = 0;
      this.projectLomCurrency = 0;
      this.projectLomFileContent = "";
      this.projectLomYearAdjustment = 0;
      this.projectLomIsPublic = true;
      this.file = "";
      this.showInvalidFileError = 0;
      this.selectedTab = 0;
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id: this.projectLomId,
            name: this.projectLomName,
            version: this.projectLomVersion,
            description : this.projectLomDescription,
            projectId : this.selectedProjectSource === this.EXTERNAL_PROJECT ? this.projectLomProjectId : null,
            hyperionEntityId : this.selectedProjectSource === this.HYPERION_PROJECT ? this.projectLomHyperionEntityId : "",
            type : this.projectLomType,
            currency : this.projectLomCurrency,
            yearAdjustment : this.projectLomYearAdjustment,
            isPublic : this.projectLomIsPublic
          };
          this.$vs.loading();

          if (this.projectLomId !== null && this.projectLomId > 0) {
            this.$store.dispatch("cashflow/updateProjectLom", obj).then(() => {
              this.$emit("onProjectLomUpdated");
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("cashflow/addProjectLom", obj).then((response) => {
              this.$emit("onProjectLomInserted");
              this.projectLomId = response.data.id;
              this.selectedTab = 1;
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    },
    uploadFile() {
      if (this.projectLomId !== null && this.projectLomId > 0) {
        const formData = new FormData();
        formData.append("files", this.file);
        formData.append("projectLomId", this.projectLomId);
        formData.append("yearAdjustment",  this.projectLomYearAdjustment);

        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        this.$emit("onProjectLomUploading");
        this.$webApi.post('cashflow/projectLom/upload/', formData, config)
          .then((response) => {
            if (response.status === 200) {
              this.$emit("onProjectUploadCompleted");
            }
          }).catch((error) => {
            this.$emit("onProjectUploadFailed", error);
          });
      }
    }
  }
};
</script>
